var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKioskCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-279.46 -402.856)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-219.125 24.073)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(522.858 392.927)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.7,30.1V13.2H21c0.5,0,0.8-0.4,0.8-0.8V5c0-0.5-0.4-0.8-0.8-0.8H11c-0.4,0-0.8,0.4-0.8,0.8v7.3 c0,0.5,0.4,0.8,0.8,0.8h1.4v16.9c-2,0.3-4.9,1-4.9,2.8c0,2.4,5.4,3,8.6,3s8.6-0.6,8.6-3C24.6,31.1,21.8,30.4,19.7,30.1z  M11.9,11.6V5.9h8.3v5.7h-0.5V8.3c0-0.5-0.4-0.8-0.8-0.8h-5.6c-0.5,0-0.8,0.4-0.8,0.8v3.3L11.9,11.6z M14,23.4V9.1h4v14.3H14z  M18,25.1V32h-4v-6.9H18z M16,34.2c-4.5,0-6.7-1-6.9-1.3c0.1-0.2,0.9-0.8,3.3-1.2v1.1c0,0.5,0.4,0.8,0.8,0.8h5.6 c0.5,0,0.8-0.4,0.8-0.8v-1.1c1.2,0.1,2.3,0.4,3.3,1C22.8,33.2,20.5,34.2,16,34.2L16,34.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.4,404.5l0.7-1.1c0.3-0.5,1.1-0.7,1.6-0.4l8,5c0.5,0.3,0.7,1.1,0.4,1.6l-0.6,1l2,1.2l0.6-1 c0.3-0.5,1.1-0.7,1.6-0.4l3,1.9c0.5,0.3,0.7,1.1,0.4,1.6l-5,8c-0.3,0.5-1.1,0.7-1.6,0.4l-3-1.9c-0.5-0.3-0.7-1.1-0.4-1.6l0.6-1 l-2-1.2l-0.6,1c-0.3,0.5-1.1,0.7-1.6,0.4l-1-0.6l-11.8,18.9c-1,1.6-3.2,2.1-4.8,1.1c-1.6-1-2.1-3.2-1.1-4.8l11.8-18.9l-1-0.6 c-0.5-0.3-0.7-1.1-0.4-1.6l0.6-0.9c-2.6-0.9-5.5-0.4-7.8,1.2c-0.5,0.3-1.3,0.2-1.6-0.4c-0.2-0.4-0.2-0.8,0-1.2l0.1-0.1 c0.1-0.1,0.1-0.2,0.2-0.3C286.5,404.7,292.1,402.6,296.4,404.5z M306.6,419.1l1,0.6l3.7-6l-1-0.6L306.6,419.1z M305.9,415.8l1.2-2 l-2-1.2l-1.2,2L305.9,415.8z M301.3,414.4l3.1-5l-6-3.7l-3.7,6l6,3.7L301.3,414.4z M283.6,433.8c-0.4,0.5-0.2,1.3,0.3,1.6 c0.5,0.4,1.3,0.2,1.6-0.3c0,0,0-0.1,0-0.1l11.8-18.9l-2-1.2L283.6,433.8z M293.9,408.5l1.2-2c-2.4-0.7-4.9-0.2-6.9,1.3 C290.1,407.5,292.1,407.7,293.9,408.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKioskCreate);
export default __webpack_public_path__ + "static/media/kiosk-create.93b3568d502e2156b55ed9af7934ef51.svg";
export { ForwardRef as ReactComponent };